import classNames from "classnames";
import React from "react";
export const LoadingSpinner = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    small = false
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex content-center ".concat(className || ""),
    ref: ref
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames("spinner", {
      "spinner-sm": small
    })
  }));
});